import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";

export const BackToLobby = ({ className = "", to = "/", label }) => {
  const nav = useNavigate();
  const { t } = useLang();
  return (
    <button
      data-testid="back-to-lobby-btn"
      onClick={() => nav(to)}
      className={`inline-flex items-center gap-1 bg-white border-2 border-navy rounded-full px-3 py-1.5 font-bebas text-navy text-sm sm:text-base tracking-wider shadow-[0_6px_20px_rgba(0,0,0,0.25)] hover:translate-y-[-1px] active:translate-y-[1px] transition-all ${className}`}
      title={t("common.backToLobby")}
    >
      {label || t("common.backToLobby")}
    </button>
  );
};
